import { useRef } from 'react';
import React from "react";
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const ContactUs = () => {

  // toast.configure();
  const notify = () => toast.success("Send Successfully",{autoClose:5000});
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_dsw8cpe', 'template_mw1zjgn', form.current, {publicKey: 'DoBbHzwqVAnb2BMoo',})
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <>
      <section class="section" id="contact"  data-aos="zoom-in-up"  data-aos-duration="1000">
          <div class="container text-center">
            <h1 className="tc mt-5 text-center">CONTACT ME</h1>
              <p class="section-subtitle">How can you communicate?</p>
              <form class='contact-form col-md-10 col-lg m-auto my-5' ref={form} onSubmit={sendEmail}><input type='hidden' name='from_name' value='form 1' />
                  <div class="row">
                      <div class="form-group col-sm-12 col-md-6 my-3">
                          <input type="text" name="user_name" size="50" class="form-control formbg" placeholder="Your Name" autofocus autocomplete="off" required />
                      </div>
                      <div class="form-group col-sm-12 col-md-6 my-3">
                          <input type="email" name="user_email" class="form-control formbg" placeholder="Enter Email" autocomplete="off" requried />
                      </div>
                      <div class="form-group col-sm-12 my-3">
                          <textarea name="message" id="comment" rows="6" class="form-control formbg"
                              placeholder="Write Something" required></textarea>
                      </div>
                      <div class="form-group col-sm-12 mt-3">
                          <input type="submit" value="Send" class="btn btn-outline-warning" style={{background:"#00906c"}} onClick={notify}/>
                          <ToastContainer />
                      </div>
                  </div>
              </form>
          </div>
      </section>
    </>
  );
};

export default ContactUs;
